import { TFunction } from 'hooks/useI18n';
import { SectionHeroDataProps } from '../shared/sectionHero/SectionHero.types';
import { SwitcherProps } from '../shared/switcher/Switcher.types';
import LeastWantedTechsByFrameworks from './charts/LeastWantedTechsByFrameworks';
import LeastWantedTechsByLanguage from './charts/LeastWantedTechsByLanguage';
import LeastWantedTechsByOther from './charts/LeastWantedTechsByOther';
import MostUsedTechsByFrameworks from './charts/MostUsedTechsByFrameworks';
import MostUsedTechsByLanguage from './charts/MostUsedTechsByLanguage';
import MostUsedTechsByOther from './charts/MostUsedTechsByOther';
import ExperienceByRole from './ExperienceByRole';
import { ExperienceByRoleProps, SoftSkillsChartProps } from './Talent.types';

export const HERODATA = (t: TFunction): SectionHeroDataProps[] => [
  {
    value: '16.5%',
    desc: t('mandecar23.talent.hero.key-point-1')
  },
  {
    value: '48%',
    desc: t('mandecar23.talent.hero.key-point-2')
  },
  {
    value: '42.9%',
    desc: t('mandecar23.talent.hero.key-point-3')
  },
  {
    value: '27%',
    desc: t('mandecar23.talent.hero.key-point-4')
  }
];

export const MOSTUSEDTECHSTABS = (t: TFunction): SwitcherProps => ({
  tabsName: 'mostUsedTechs',
  tabs: [
    {
      id: 'mostUsedTechsByLang',
      label: t('mandecar23.talent.most-used-techs.languages'),
      content: <MostUsedTechsByLanguage />
    },
    {
      id: 'mostUsedTechsByFrameworks',
      label: t('mandecar23.talent.most-used-techs.frameworks'),
      content: <MostUsedTechsByFrameworks />
    },
    {
      id: 'mostUsedTechsByOther',
      label: t('mandecar23.talent.most-used-techs.other-techs'),
      content: <MostUsedTechsByOther />
    }
  ]
});

export const MOSTUSEDTECHSBYLANGUAGE = [
  {
    value: 16.504588787219785,
    language: 'JavaScript',
    fill: '#08306B'
  },
  {
    value: 11.636781420540807,
    language: 'HTML',
    fill: '#08306B'
  },
  {
    value: 11.624471708177753,
    language: 'CSS',
    fill: '#08519C'
  },
  {
    value: 10.330584164238918,
    language: 'JAVA',
    fill: '#08519C'
  },
  {
    value: 9.753395428993477,
    language: 'Python',
    fill: '#2171B5'
  },
  {
    value: 7.748280059633718,
    language: 'SQL',
    fill: '#2171B5'
  },
  {
    value: 6.451657024058649,
    language: 'PHP',
    fill: '#4292C6'
  },
  {
    value: 5.543473800828854,
    language: 'TypeScript',
    fill: '#4292C6'
  },
  {
    value: 3.505532531834284,
    language: 'C#',
    fill: '#6BAED6'
  },
  {
    value: 2.2020707671686295,
    language: 'C++',
    fill: '#6BAED6'
  }
];

export const MOSTUSEDTECHSBYFRAMEWORKS = [
  {
    value: 13.739688174428691,
    language: 'React',
    fill: '#08306B'
  },
  {
    value: 6.40795498093951,
    language: 'Angular2+',
    fill: '#08306B'
  },
  {
    value: 4.8609290223683415,
    language: 'Bootstrap',
    fill: '#08519C'
  },
  {
    value: 4.590653300792674,
    language: 'Vue',
    fill: '#08519C'
  },
  {
    value: 4.354666290163174,
    language: 'Express',
    fill: '#2171B5'
  },
  {
    value: 4.04405090865084,
    language: 'Spring Boot',
    fill: '#2171B5'
  },
  {
    value: 3.7818431190625064,
    language: 'Spring',
    fill: '#4292C6'
  },
  {
    value: 3.5478730914298393,
    language: 'jQuery',
    fill: '#4292C6'
  },
  {
    value: 3.5196353294741725,
    language: '.NET',
    fill: '#6BAED6'
  },
  {
    value: 2.9024385324431714,
    language: 'Laravel',
    fill: '#6BAED6'
  }
];

export const MOSTUSEDTECHSBYOTHER = [
  {
    value: 4.186463092930664,
    language: 'Git',
    fill: '#08306B'
  },
  {
    value: 4.165471300721418,
    language: 'MySQL',
    fill: '#08306B'
  },
  {
    value: 3.933861860012735,
    language: 'NodeJS',
    fill: '#08519C'
  },
  {
    value: 3.4419541959093998,
    language: 'Docker',
    fill: '#08519C'
  },
  {
    value: 3.2236395569332386,
    language: 'MongoDB',
    fill: '#2171B5'
  },
  {
    value: 2.4889268296096225,
    language: 'AWS',
    fill: '#2171B5'
  },
  {
    value: 2.36647470838902,
    language: 'PostgreSQL',
    fill: '#4292C6'
  },
  {
    value: 2.1341655412733624,
    language: 'Jira',
    fill: '#4292C6'
  },
  {
    value: 2.101278400145543,
    language: 'Linux',
    fill: '#6BAED6'
  },
  {
    value: 2.0215095897504076,
    language: 'Github',
    fill: '#6BAED6'
  }
];

export const LEASTWANTEDTECHSTABS = (t: TFunction): SwitcherProps => ({
  tabsName: 'leastWantedTechs',
  tabs: [
    {
      id: 'leastWantedTechsByLang',
      label: t('mandecar23.talent.least-wanted-techs.languages'),
      content: <LeastWantedTechsByLanguage />
    },
    {
      id: 'leastWantedTechsByFrameworks',
      label: t('mandecar23.talent.least-wanted-techs.frameworks'),
      content: <LeastWantedTechsByFrameworks />
    },
    {
      id: 'leastWantedTechsByOther',
      label: t('mandecar23.talent.least-wanted-techs.other-techs'),
      content: <LeastWantedTechsByOther />
    }
  ]
});

export const LEASTWANTEDTECHSBYLANGUAGE = [
  {
    value: 27.328020134228186,
    language: 'JAVA',
    fill: '#08306B'
  },
  {
    value: 21.161912751677853,
    language: 'PHP',
    fill: '#08306B'
  },
  {
    value: 6.333892617449664,
    language: 'C++',
    fill: '#08519C'
  },
  {
    value: 5.39010067114094,
    language: 'Python',
    fill: '#08519C'
  },
  {
    value: 5.369127516778524,
    language: 'C#',
    fill: '#2171B5'
  },
  {
    value: 4.865771812080537,
    language: 'Cobol',
    fill: '#2171B5'
  },
  {
    value: 4.823825503355705,
    language: 'JavaScript',
    fill: '#4292C6'
  },
  {
    value: 4.656040268456376,
    language: 'C',
    fill: '#4292C6'
  },
  {
    value: 3.1459731543624163,
    language: 'CSS',
    fill: '#6BAED6'
  },
  {
    value: 2.2441275167785233,
    language: 'HTML',
    fill: '#6BAED6'
  }
];

export const LEASTWANTEDTECHSBYFRAMEWORKS = [
  {
    value: 23.56164383561644,
    language: '.NET',
    fill: '#08306B'
  },
  {
    value: 17.35159817351598,
    language: 'AngularJS',
    fill: '#08306B'
  },
  {
    value: 10.684931506849315,
    language: 'Angular2+',
    fill: '#08519C'
  },
  {
    value: 8.812785388127855,
    language: 'React',
    fill: '#08519C'
  },
  {
    value: 6.164383561643835,
    language: 'jQuery',
    fill: '#2171B5'
  },
  {
    value: 3.5616438356164384,
    language: 'Vue',
    fill: '#2171B5'
  },
  {
    value: 3.2420091324200913,
    language: '.Net Core',
    fill: '#4292C6'
  },
  {
    value: 2.7853881278538815,
    language: 'React Native',
    fill: '#4292C6'
  },
  {
    value: 1.872146118721461,
    language: 'ASP.net',
    fill: '#6BAED6'
  },
  {
    value: 1.82648401826484,
    language: 'Laravel',
    fill: '#6BAED6'
  }
];

export const LEASTWANTEDTECHSBYOTHER = [
  {
    value: 6.976744186046512,
    language: 'WordPress',
    fill: '#08306B'
  },
  {
    value: 6.064751481988144,
    language: 'Windows',
    fill: '#08306B'
  },
  {
    value: 3.146374829001368,
    language: 'Autodesk 3D Studio Max',
    fill: '#08519C'
  },
  {
    value: 2.644778841769266,
    language: 'SAP',
    fill: '#08519C'
  },
  {
    value: 2.5079799361605106,
    language: 'NodeJS',
    fill: '#2171B5'
  },
  {
    value: 2.0519835841313268,
    language: 'Oracle',
    fill: '#2171B5'
  },
  {
    value: 2.0063839489284083,
    language: 'Android',
    fill: '#4292C6'
  },
  {
    value: 1.7327861377108982,
    language: 'MySQL',
    fill: '#4292C6'
  },
  {
    value: 1.6415868673050615,
    language: 'Azure',
    fill: '#6BAED6'
  },
  {
    value: 1.595987232102143,
    language: 'Drupal',
    fill: '#6BAED6'
  }
];

export const SOFTSKILLS = (
  locale: string | undefined
): SoftSkillsChartProps[] => [
  {
    skill: {
      en: 'Team player',
      es: 'Trabajo en equipo'
    },
    offers: 10.101382488479263,
    users: 10.932951678633804
  },
  {
    skill: {
      en: 'Proactivity',
      es: 'Proactividad'
    },
    offers: 9.253456221198157,
    users: 6.430719968950125
  },
  {
    skill: {
      en: 'Continuous learning',
      es: 'Aprendizaje Continuo'
    },
    offers: 8.534562211981566,
    users: 14.513390258102078
  },
  {
    skill: {
      en: 'Capacity for self-management ',
      es: 'Capacidad de autogestión'
    },
    offers: 8.036866359447005,
    users: 3.927323888996701
  },
  {
    skill: {
      en: 'Attention to detail',
      es: 'Atención al detalle'
    },
    offers: 7.336405529953917,
    users: 5.5841257519891325
  },
  {
    skill: {
      en: 'Adaptability to change',
      es: 'Adaptabilidad al cambio'
    },
    offers: 6.63594470046083,
    users: 11.017853677469436
  },
  {
    skill: {
      en: 'Good verbal communication',
      es: 'Comunicación verbal'
    },
    offers: 5.806451612903226,
    users: 1.4748690083446536
  },
  {
    skill: {
      en: 'Analytical thinking',
      es: 'Pensamiento analítico'
    },
    offers: 4.9953917050691246,
    users: 7.316126528235979
  },
  {
    skill: {
      en: 'Autonomy in learning',
      es: 'Autonomía en el aprendizaje'
    },
    offers: 4.571428571428571,
    users: 6.765476421502038
  },
  {
    skill: {
      en: 'Leadership skills',
      es: 'Liderazgo'
    },
    offers: 4.018433179723503,
    users: 4.327576169221812
  },
  {
    skill: {
      en: 'Ability to give feedback',
      es: 'Capacidad de dar feedback'
    },
    offers: 3.576036866359447,
    users: 1.4991267222976907
  },
  {
    skill: {
      en: 'Strategic vision',
      es: 'Visión estratégica'
    },
    offers: 3.336405529953917,
    users: 2.396662138560062
  },
  {
    skill: {
      en: 'Good written communication',
      es: 'Comunicación escrita'
    },
    offers: 3.299539170506913,
    users: 0.7762468464971861
  }
];

export const EXPERIENCEBYROLEBYLANGUAGE: ExperienceByRoleProps[] = [
  {
    tech: 'C#',
    tier2: 25.665236051502145,
    tier4: 35.407725321888414,
    tier3: 22.660944206008583,
    tier1: 16.266094420600858
  },
  {
    tech: 'C++',
    tier1: 19.2524682651622,
    tier4: 33.779971791255285,
    tier2: 26.375176304654442,
    tier3: 20.59238363892807
  },
  {
    tech: 'CSS',
    tier3: 19.70372501078671,
    tier1: 33.0504818064145,
    tier4: 18.366172875017977,
    tier2: 28.87962030778081
  },
  {
    tech: 'HTML',
    tier1: 32.64981949458484,
    tier3: 20.014440433212997,
    tier4: 18.642599277978338,
    tier2: 28.693140794223826
  },
  {
    tech: 'JAVA',
    tier2: 24.903187369675305,
    tier3: 22.981829014000596,
    tier1: 19.37742031575812,
    tier4: 32.73756330056598
  },
  {
    tech: 'JavaScript',
    tier2: 28.375241779497102,
    tier1: 26.42166344294004,
    tier4: 23.143133462282396,
    tier3: 22.059961315280464
  },
  {
    tech: 'PHP',
    tier2: 22.14968524131499,
    tier1: 16.927022615994407,
    tier3: 25.763581254371648,
    tier4: 35.159710888318955
  },
  {
    tech: 'Python',
    tier3: 22.425997425997426,
    tier4: 26.512226512226512,
    tier2: 29.906692406692407,
    tier1: 21.155083655083658
  },
  {
    tech: 'SQL',
    tier1: 20.30284917314206,
    tier2: 29.647340107591152,
    tier4: 27.256425582785415,
    tier3: 22.79338513648137
  },
  {
    tech: 'TypeScript',
    tier2: 34.51255738590332,
    tier1: 22.306238185255197,
    tier3: 24.60167431812044,
    tier4: 18.579530110721038
  }
];

export const EXPERIENCEBYROLEBYFRAMEWORK: ExperienceByRoleProps[] = [
  {
    tech: 'Angular2+',
    tier2: 30.29197080291971,
    tier1: 15.19575315195753,
    tier3: 29.329794293297944,
    tier4: 25.18248175182482
  },
  {
    tech: 'Bootstrap',
    tier3: 16.860171630489653,
    tier2: 26.653205451792022,
    tier4: 18.67743563856638,
    tier1: 37.80918727915194
  },
  {
    tech: 'Express',
    tier4: 11.52310325156874,
    tier3: 16.543069024529377,
    tier2: 28.465487735310894,
    tier1: 43.468339988590984
  },
  {
    tech: 'jQuery',
    tier3: 27.9322853688029,
    tier4: 35.489721886336156,
    tier1: 12.6360338573156,
    tier2: 23.941958887545344
  },
  {
    tech: 'Laravel',
    tier2: 28.330781010719758,
    tier3: 27.488514548238896,
    tier4: 26.263399693721283,
    tier1: 17.917304747320063
  },
  {
    tech: '.NET',
    tier3: 25.269461077844312,
    tier1: 10.538922155688622,
    tier4: 42.93413173652695,
    tier2: 21.25748502994012
  },
  {
    tech: 'React',
    tier3: 20.658263305322127,
    tier4: 16.509103641456583,
    tier1: 31.915266106442573,
    tier2: 30.917366946778714
  },
  {
    tech: 'Spring',
    tier2: 23.721191680719507,
    tier4: 39.34794828555368,
    tier3: 25.576166385609895,
    tier1: 11.354693648116921
  },
  {
    tech: 'Spring Boot',
    tier2: 26.35616438356164,
    tier1: 16.931506849315067,
    tier3: 24.71232876712329,
    tier4: 32
  },
  {
    tech: 'Vue',
    tier2: 30.736743312998595,
    tier4: 23.04082590333177,
    tier1: 17.08118254340685,
    tier3: 29.141248240262783
  }
];

export const EXPERIENCEBYROLEBYOTHER: ExperienceByRoleProps[] = [
  {
    tech: 'AWS',
    tier2: 24.22543523163175,
    tier4: 39.74623782826793,
    tier3: 28.031867807612866,
    tier1: 7.99645913248746
  },
  {
    tech: 'Docker',
    tier3: 27.82275244993609,
    tier2: 27.37537281636131,
    tier4: 33.4043459735833,
    tier1: 11.3975287601193
  },
  {
    tech: 'Git',
    tier1: 22.599925289503176,
    tier3: 24.24355621964886,
    tier4: 23.47777362719462,
    tier2: 29.678744863653346
  },
  {
    tech: 'Github',
    tier2: 27.516778523489933,
    tier3: 19.630872483221477,
    tier1: 34.22818791946309,
    tier4: 18.624161073825505
  },
  {
    tech: 'Jira',
    tier1: 10.483042137718398,
    tier3: 28.126070572113736,
    tier2: 27.132579650565265,
    tier4: 34.258307639602606
  },
  {
    tech: 'Linux',
    tier2: 23.079723334546777,
    tier4: 40.51692755733527,
    tier1: 13.214415726246814,
    tier3: 23.18893338187113
  },
  {
    tech: 'MongoDB',
    tier3: 23.084455324357407,
    tier1: 25.018359853121176,
    tier2: 27.148102815177477,
    tier4: 24.749082007343944
  },
  {
    tech: 'MySQL',
    tier3: 24.627720504009165,
    tier4: 30.794196258113782,
    tier2: 23.749522718594886,
    tier1: 20.82856051928217
  },
  {
    tech: 'NodeJS',
    tier1: 28.674203494347378,
    tier3: 22.302158273381295,
    tier4: 20.431654676258994,
    tier2: 28.591983556012334
  },
  {
    tech: 'PostgreSQL',
    tier3: 25,
    tier2: 27.706185567010312,
    tier4: 29.961340206185564,
    tier1: 17.332474226804123
  }
];

export const EXPERIENCEBYROLETABS = (t: TFunction): SwitcherProps => ({
  tabsName: 'experienceByRole',
  tabs: [
    {
      id: 'experienceByRoleByLang',
      label: t('mandecar23.talent.main-techs.languages'),
      content: <ExperienceByRole data={EXPERIENCEBYROLEBYLANGUAGE} />
    },
    {
      id: 'experienceByRoleByFramework',
      label: t('mandecar23.talent.main-techs.frameworks'),
      content: <ExperienceByRole data={EXPERIENCEBYROLEBYFRAMEWORK} />
    },
    {
      id: 'experienceByRoleByOther',
      label: t('mandecar23.talent.main-techs.other-techs'),
      content: <ExperienceByRole data={EXPERIENCEBYROLEBYOTHER} />
    }
  ]
});
